import axios from 'axios';
import { APIURL }  from './index';

export const MYFAVORITE = 'MYFAVORITE';
export const MYFAVORITE_ISLOADING = 'MYFAVORITE_ISLOADING';
export const MYFAVORITE_ERROR = 'MYFAVORITE_ERROR';


export function fetch_myfavorite(userId, formdata, type, token, dispatch) {
  let url = ''

  return (dispatch) => {
    let request;
    switch (type) {
      case 'get':
        url = `${APIURL}/KOLAccount/${userId}/collection/kols?token=${token}`;
        request = axios.get(url);
        break;
      case 'get_kolId':
        url = `${APIURL}/KOLAccount/${userId}/collection/kols?kolId=${formdata}&token=${token}`;
        request = axios.get(url);
        break;
      case 'post':
        url = `${APIURL}/KOLAccount/${userId}/collection/kols?token=${token}`;
        request = axios.post(url, formdata, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        break;
      case 'put':
        url = `${APIURL}/KOLAccount/${userId}/collection/kols?token=${token}`;
        request = axios.put(url, formdata, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        break;
      case 'delete':
        url = `${APIURL}/KOLAccount/${userId}/collection/kols/${formdata}?token=${token}`;
        request = axios.delete(url);
        break;
      default:
        break;
    }

    dispatch(myfavorite_isloading(true))
    request.then((response) =>{
      dispatch(myfavorite_error(false))
      return response;
    })
    .then((response)=>{
      dispatch(myfavorite_success(response))
      dispatch(myfavorite_isloading(false))
    })
    .catch((err) => {
      console.log(err)
      dispatch(myfavorite_isloading(false))
      return dispatch(myfavorite_error(err.response))
    });
  }

}

export function myfavorite_isloading(bool){
  return {
    type:MYFAVORITE_ISLOADING,
    isLoading: bool
  }
}

export function myfavorite_success(response){
	return {
		type:MYFAVORITE,
		payload: response
	}
}

export function myfavorite_error(bool){
	return {
		type:MYFAVORITE_ERROR,
    hasErrored:bool
	}
}




// WEBPACK FOOTER //
// ./src/actions/fetch_myfavorite.js